import { render, staticRenderFns } from "./picker-article.vue?vue&type=template&id=8ccabcc8"
import script from "./picker-article.vue?vue&type=script&lang=js"
export * from "./picker-article.vue?vue&type=script&lang=js"
import style0 from "./picker-article.vue?vue&type=style&index=0&id=8ccabcc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-load_8b2b7732cc741d077553b84f33555b65/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports